import { Link } from "react-router-dom";
import UserIdentityLabel from "./UserIdentityLabel";

const DEFAULT_USERNAME_LINK_TRUNCATE_AT = 18;

export default function BrowseUserIdentityLink({
  to,
  state,
  onClick,
  username,
  tier,
  role = "collector",
  size = "sm",
  color = "#0f766e",
  fontWeight = 700,
  wrap = false,
  truncateAt = DEFAULT_USERNAME_LINK_TRUNCATE_AT,
  stopPropagation = false,
  style = {},
  className = "",
  asButton = false
}) {
  const handleClick = (event) => {
    if (stopPropagation) {
      event.stopPropagation();
    }

    onClick?.(event);
  };

  const content = (
    <UserIdentityLabel
      username={username}
      tier={tier}
      role={role}
      size={size}
      color={color}
      fontWeight={fontWeight}
      wrap={wrap}
      truncateAt={truncateAt}
    />
  );

  if (asButton) {
    return (
      <button type="button" onClick={handleClick} className={`user-identity-link ${className}`.trim()} style={{ color, ...style }}>
        {content}
      </button>
    );
  }

  return (
    <Link to={to} state={state} onClick={handleClick} className={`user-identity-link ${className}`.trim()} style={{ color, ...style }}>
      {content}
    </Link>
  );
}